import { __exports as t } from "./index81.js";
import "./index144.js";
import "./index145.js";
import { __exports as u } from "./index146.js";
import { __exports as E } from "./index147.js";
Object.defineProperty(t, "__esModule", { value: !0 });
t.default = P;
var i = u, O = E, T = ["checked", "value"], d = ["input", "select", "textarea"], p = {
  reset: !0,
  submit: !0
};
function P(r, c) {
  r === void 0 && (r = {});
  var e = {}, f = !!(r.type && p[r.type]);
  for (var s in r) {
    var n = r[s];
    if ((0, i.isCustomAttribute)(s)) {
      e[s] = n;
      continue;
    }
    var v = s.toLowerCase(), o = _(v);
    if (o) {
      var l = (0, i.getPropertyInfo)(o);
      switch (T.includes(o) && d.includes(c) && !f && (o = _("default" + v)), e[o] = n, l == null ? void 0 : l.type) {
        case i.BOOLEAN:
          e[o] = !0;
          break;
        case i.OVERLOADED_BOOLEAN:
          n === "" && (e[o] = !0);
          break;
      }
      continue;
    }
    O.PRESERVE_CUSTOM_ATTRIBUTES && (e[s] = n);
  }
  return (0, O.setStyleProp)(r.style, e), e;
}
function _(r) {
  return i.possibleStandardNames[r];
}
